import Vue from 'vue';
import vue2Dropzone from 'vue2-dropzone';

export default Vue.extend({
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFiles: 3,
        dictDefaultMessage: '<div class="dropzone-icon"><svg class="icon"><use xlink:href="/img/icons/icons-sprite.svg#drop-file-zone"/></svg></div><div class="dropzone-text">Choose a file or drag it here<br>(*.jpg, *.jpeg, *.png, max size 5mb)</div>',
        addedfile: (file) => {
          const acceptedExtensions = ['png', 'jpg', 'jpeg'];
          const fileExtension = file.type.split('/')[1].toString();
          if (!acceptedExtensions.includes(fileExtension)) {
            return this.$root.$emit('notification', {
              message: `file extension must be either of : <br/> ${acceptedExtensions.map((el) => ' ' + el + ' ')}`,
              type: 'error',
              show: true,
            });
          }
          if ((file.size / (1000 * 1000)) > 5) {
            return this.$root.$emit('notification', {
              message: `Size file: ${file.name} more 5 MB`,
              type: 'error',
              show: true,
            });
          }
          this.getDocumentContentAsJson(file)
            .then((data) => {
              file.dataURL = data;
              this.addUploadFile(file);
              this.addNewSelectedLogo(file.dataURL);
            })
            .catch((err) => {
              this.$root.$emit('notification', {
                message: `error occured during upload, <br /> ${err}`,
                type: 'error',
                show: true,
              });
            });
        },
      },
      selectedLogo: '',
      logoList: [],
      LogoListData: [],
    };
  },
  created() {
    this.getSelectedLogo();
    this.getLogos();
  },
  methods: {
    addUploadFile(file) {
      this.LogoListData.push({
        Name: file.name,
        DataUrl: file.dataURL,
        FileSize: file.size,
        FileType: `.${file.name.split('.').pop()}`,
      });
    },
    getDocumentContentAsJson(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getLogos() {
      this.logoList = this.$store.getters.mainAppLogo.currentLogos;
    },
    getSelectedLogo() {
      this.selectedLogo = this.$store.getters.mainAppLogo.selectedLogo;
    },
    addNewSelectedLogo(logo) {
      this.$store.dispatch('SET_LOGO', logo);
      this.$store.dispatch('EDIT_LOGO_LIST', {
        type: 'add',
        image: logo,
      });

      this.getLogos();
      this.getSelectedLogo();
    },
    selectCurrentLogo(logo) {
      this.$store.dispatch('SET_LOGO', logo);
      this.getSelectedLogo();
    },
    removeLogo(image) {
      if (this.logoList.length < 2) {
        this.$root.$emit('notification', {
          message: 'logo list must contain at least one element!',
          type: 'error',
          show: true,
        });
      } else {
        this.$store.dispatch('EDIT_LOGO_LIST', {
          type: 'remove',
          image: image,
        });
        this.getLogos();
        this.getSelectedLogo();
      }
    },
    confirmRemove(image) {
      if (this.logoList.length < 2) {
        this.$root.$emit('notification', {
          message: 'logo list must contain at least one element!',
          type: 'error',
          show: true,
        });
      } else {
        this.$modal.show('dialog', {
          title: 'Warning!',
          text: 'Are you sure you want to delete this logo?',
          buttons: [{
            title: 'Yes',
            handler: () => {
              this.removeLogo(image);
              this.$modal.hide('dialog');
            },
          }, {
            title: 'No',
          }],
        });
      }
    },
  },
});
